import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { trackLead } from "../../lib/track";

const TELEGRAM_URL = "https://t.me/+cr1LhxIMB-5jODJl";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkCls =
    "text-[12.5px] tracking-[0.18em] uppercase text-white/60 hover:text-white transition-colors duration-300";

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.2, 0.7, 0.2, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "backdrop-blur-xl bg-[#04060a]/60 border-b border-white/[0.05]" : ""
      }`}
      data-testid="navbar"
    >
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 h-[72px] flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
          <div
            className="relative h-8 w-8 rounded-full ring-1 ring-white/10"
            style={{
              backgroundImage: `url(/assets/logo.png)`,
              backgroundSize: "180%",
              backgroundPosition: "center 22%",
              backgroundRepeat: "no-repeat",
            }}
            aria-label="BIGBULL"
          />
          <span className="font-display text-[15px] tracking-[0.24em] font-medium text-white/90">
            BIGBULL
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          <a href="#why" className={linkCls} data-testid="nav-why">Why</a>
          <a href="#vip" className={linkCls} data-testid="nav-vip">VIP</a>
          <a href="#signals" className={linkCls} data-testid="nav-signals">Signals</a>
          <a href="#contact" className={linkCls} data-testid="nav-contact">Contact</a>
        </nav>

        <a
          href={TELEGRAM_URL}
          target="_blank"
          rel="noreferrer"
          onClick={() => trackLead("nav_telegram")}
          className="btn-pill btn-secondary-glass text-[11.5px] py-2.5 px-4"
          data-testid="nav-cta"
        >
          Join Telegram
          <span className="opacity-70">→</span>
        </a>
      </div>
    </motion.header>
  );
};

export default Navbar;
